module.exports = __webpack_public_path__ + "static/media/Des-Tra-Men.195f2a09.png";